<template>
  <div class="ui form segment" id="new-reservation-type-step" style="">
    <div class="field">
      <label for="name">{{ $t('reservationTypeName') }}</label>
      <div class="ui input">
        <input type="text"
               v-model="reservationType.name"
               :placeholder="$t('reservationTypeName')"
               name="name">
      </div>
    </div>
    <div class="field">
      <label for="price">{{ $t('price') }}</label>
      <div class="ui input">
        <input type="number"
               v-model.number="reservationType.price"
               :placeholder="$t('price')"
               name="price">
      </div>
    </div>
    <div class="inline fields">
      <label for="duration">{{ $t('duration') }}</label>
      <div class="field">
        <div class="ui input">
          <input type="number"
                 :placeholder="$t('hours')"
                 v-model.number="reservationType.hours"
                 name="hours">
        </div>
      </div>
      <strong style="padding-right: 10px;font-size: 20px">:</strong>
      <div class="field">
        <div class="ui input">
          <input type="number"
                 v-model.number="reservationType.minutes"
                 :placeholder="$t('minutes')"
                 name="minutes">
        </div>
      </div>
    </div>

    <br/>

    <div class="ui blue right floated right labeled icon button"
         style="background-color: #092442"
         @click="next()">
      <i class="right arrow icon"></i>
      Next
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      reservationType: {
        name: '',
        price: null,
        hours: null,
        minutes: null
      }
    }
  },
  mounted () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#new-reservation-type-step').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              identifier: 'name',
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Enter a name for your new reservation type'
                }
              ]
            },
            price: {
              identifier: 'price',
              rules: [
                {
                  type: 'decimal',
                  prompt: 'Please, Enter a price for your new reservation type'
                }
              ]
            },
            minutes: {
              identifier: 'minutes',
              rules: [
                {
                  type: 'integer',
                  prompt: 'Please, Enter a minutes for your new reservation type'
                }
              ]
            }
          }
        })
      })
    },
    next () {
      this.$emit('reservationType-step1Changes', {
        data: {
          reservationTypeInfo: this.reservationType,
          next: $('#new-reservation-type-step').form('is valid')
        }
      })
    }
  }
}
</script>

<style scoped>
  #new-reservation-type-step {
    padding-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/reservation_types/new_reservation_type_steps/ReservationTypeInfoStep.vue